import React, {useEffect, useRef, useState} from 'react';
import Classes from "classnames";
import UI5ControlButton from "../../../../layout/app-controls/buttons/button/button";
import AddReaction_AllReactions from "./all-reactions";
import AddReaction_FavoriteReactions from "./favorite-reactions";

type Props = {
    menuParams: {
        onSelect        : callback
    }
}

export default function AddReaction_PopoverContent(props: Props) {

    const popoverParent = useRef<any>()

    const [showAll, setShowAll] = useState<boolean>(false)

    const onToggle = (value: boolean)=>{
        setShowAll(() => !showAll)
    }

    const arrowClasses = Classes("ui5-arrow-toggle fs-11 m-t-2",{
        "open-up"       : showAll,
        "closed-down"   : !showAll
    })

    useEffect(() => {
        const favoriteReactions: number[] = gd.modules.reactions.favoriteReactions;
        if(_.isEmpty(favoriteReactions)) setShowAll(true)
    }, []);

    return (
        <div className="reaction-items" ref={popoverParent}>

            {!showAll &&
                <div className="favorite-reaction-items">
                    <AddReaction_FavoriteReactions onSelect={props.menuParams.onSelect} />

                    <UI5ControlButton size="28" iconClass={arrowClasses} className="m-l-auto" onClick={onToggle} />
                </div>}

            {showAll && <AddReaction_AllReactions onSelect={props.menuParams.onSelect}/>}

        </div>
    );
}